import { MeansOfTransportType } from '../../../sharedComponents/common.types';
import { TransportInformation } from '../../compoundManagement.types';

export const getMeansOfTransportTypeValidationMessageId = ({ meansOfTransportType }: Partial<TransportInformation>) =>
    !meansOfTransportType ? 'outboundOrderBook.compoundManagement.sidebar.selectMeansOfTransportType.error' : undefined;

export const getMeansOfTransportIdValidationMessageId = ({
    meansOfTransportType,
    meansOfTransportId,
}: Partial<TransportInformation>) =>
    meansOfTransportType === MeansOfTransportType.TRUCK && !meansOfTransportId
        ? 'outboundOrderBook.compoundManagement.sidebar.truckLicensePlate.missing'
        : meansOfTransportType === MeansOfTransportType.TRAIN && !meansOfTransportId
          ? 'outboundOrderBook.compoundManagement.sidebar.wagonNumber.missing'
          : undefined;
